// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline_headline__23yAG","visible":"Headline_visible__2g4on"};